import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "../../lib/utils";

type SeparatorProps = React.ComponentProps<typeof SeparatorPrimitive.Root> & {
  variant?: "solid" | "dotted";
};

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  variant = "solid",
  style,
  ...props
}: SeparatorProps) {
  const isDotted = variant === "dotted";
  const dottedStyle: React.CSSProperties | undefined = isDotted
    ? {
        backgroundImage:
          orientation === "horizontal"
            ? "radial-gradient(var(--color-black-2) 45%, transparent 46%)"
            : "radial-gradient(var(--color-black-2) 45%, transparent 46%)",
        backgroundSize: orientation === "horizontal" ? "10px 1px" : "1px 10px",
        backgroundRepeat: "repeat-x",
        backgroundPosition: "center",
      }
    : undefined;

  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        isDotted ? "bg-transparent" : "bg-[var(--color-black-1)]",
        className
      )}
      style={{ ...dottedStyle, ...style }}
      {...props}
    />
  );
}

export { Separator };
